import React from 'react'
import Transition from 'react-transition-group/Transition';
import Link from 'gatsby-link'
import slugify from 'slugify'
import { slugifyOptions, homePageId } from '../../config'
import { isDomElement } from '../../util'

import '../Header/header.scss'
import PlusIcon from '../../assets/icons/plus-icon'


class MainNavigation extends React.Component {

  constructor(props) {
    super(props)

    this.navigation = React.createRef()
    this.closeSubmenu = this.closeSubmenu.bind(this)
    this.state = {
      showSubmenu: null,
      activeLink: ''
    }
  }

  renderLink(item, index) {
    const lang = this.props.lang
    const url = item.id && item.id.indexOf(homePageId) === 0 ? `/${lang}` : `/${lang}/${slugify(item.title, slugifyOptions)}`
    return (
      <Link 
            exact
            className="header-page-list-item-link unstyled"
            activeClassName="header-page-list-item-link-active"
            key={`${slugify(item.title, slugifyOptions)}` + index}
            to={url}
            data-cy="nav-item"
            onClick={this.setActiveLink.bind(this, item.title)}>
        {item.title}
      </Link>
    )
  }

  setActiveLink = (title) => {
    this.props.linkClicked()
    this.setState({
      activeLink: title
    })

    if (this.state.activeLink !== title) {
      this.setState({
        showSubmenu: null
      })
    } 
  }

  closeSubmenu = (event) => {
    if (!isDomElement(event.target, this.navigation.current)) {
      document.body.removeEventListener('click', this.closeSubmenu)

      this.setState({
        showSubmenu: null
      })
    }
  }

  toggleSubmenu = (i, title) => {
    if (this.state.showSubmenu === i) {
      document.body.removeEventListener('click', this.closeSubmenu)

      this.setState({
        showSubmenu: null
      })
    } else {
      document.body.addEventListener('click', this.closeSubmenu)

      this.setState({
        showSubmenu: i,
        activeLink: title
      })
    }
  }

  render() {
    return (
      <ul ref={ this.navigation } className="header-page-list" data-cy="main-navigation"> 
        {this.props.items.slice(1).map((item, i) => {
          return (
            <li key={i} className={"header-page-list-item " + (this.state.showSubmenu === i && this.state.activeLink === item.title ? 'active bg-pink-desktop-up' : '')}>
              <div className="header-page-list-item-link-wrapper">
                {this.renderLink(item)}
                {item.subPages ? 
                  <div 
                    className={"header-submenu-icon " + (this.state.showSubmenu !== null && this.state.activeLink === item.title ? 'header-submenu-icon-close' : '')} 
                    onClick={this.toggleSubmenu.bind(this, i, item.title)}>
                    <PlusIcon />
                  </div> : <div className="clear-left-mobile"></div>}
              </div>
              
              {/* Show/hide submenu */}
              <Transition
                in={this.state.showSubmenu === i && item.subPages && this.state.activeLink === item.title}
                timeout={{enter: 0, exit: 450}}
                mountOnEnter
                unmountOnExit
                appear>
                {state => (
                  <div className={"header-submenu-container " + (state === 'entering' ? 'enter-submenu' : state === 'exiting' ? 'exit-submenu' : '')}>
                    <ul className="header-submenu-list">
                      {item.subPages.map((item, index) => <li key={index} className="header-submenu-list-item">{this.renderLink(item, index)}</li>)}
                    </ul>
                  </div>
                )}
              </Transition>
            </li>
          )
        })}
      </ul>
    )
  }

}



export default MainNavigation


// WEBPACK FOOTER //
// ./src/components/Navigation/navigation.js